const FORM_SELECTOR = 'form[data-aurelia-cart-form]';

function cartSectionIds() {
  return [...document.querySelectorAll('cart-items-component')]
    .map((element) => element.dataset.sectionId)
    .filter(Boolean)
    .filter((id, index, values) => values.indexOf(id) === index);
}

function cartAddEndpoint(form) {
  const url = new URL(form.action, window.location.origin);
  if (!url.pathname.endsWith('.js')) {
    url.pathname = `${url.pathname.replace(/\/$/, '')}.js`;
  }
  return url.toString();
}

async function currentCart() {
  const root = window.Shopify?.routes?.root || '/';
  const response = await fetch(`${root.replace(/\/$/, '')}/cart.js`, {
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error('Unable to refresh the cart.');
  return response.json();
}

async function openCartDrawer() {
  await customElements.whenDefined('cart-drawer-component');
  const drawer = document.querySelector('cart-drawer-component');
  if (drawer && typeof drawer.open === 'function') {
    window.requestAnimationFrame(() => drawer.open());
  }
}

document.addEventListener('submit', async (event) => {
  const form = event.target instanceof HTMLFormElement ? event.target.closest(FORM_SELECTOR) : null;
  if (!form) return;
  if (event.submitter && event.submitter.name !== 'add') return;

  event.preventDefault();

  const button = form.querySelector('[name="add"]');
  const message = form.querySelector('[data-cart-message]');
  const originalText = button?.textContent || '';
  const addingText = form.dataset.addingText || 'Adding...';
  const addedText = form.dataset.addedText || 'Added to cart';
  const errorText = form.dataset.errorText || 'Unable to add this item. Please try again.';

  if (button) {
    button.disabled = true;
    button.textContent = addingText;
  }
  if (message) message.textContent = '';

  try {
    const formData = new FormData(form);
    const sections = cartSectionIds();
    if (sections.length) {
      formData.set('sections', sections.join(','));
      formData.set('sections_url', window.location.pathname);
    }

    const addResponse = await fetch(cartAddEndpoint(form), {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    });
    const addedItem = await addResponse.json();
    if (!addResponse.ok || addedItem.status) {
      throw new Error(addedItem.description || addedItem.message || errorText);
    }

    const cart = await currentCart();
    const quantity = Math.max(1, Number.parseInt(formData.get('quantity') || '1', 10));
    const variantId = String(formData.get('id') || '');

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: form.id || 'aurelia-product-form',
          data: {
            source: 'product-form-component',
            itemCount: quantity,
            productId: String(form.dataset.productId || ''),
            variantId,
            sections: addedItem.sections || {},
          },
        },
      })
    );

    if (message) message.textContent = addedText;
    if (button) button.textContent = addedText;
    await openCartDrawer();
  } catch (error) {
    if (message) message.textContent = error.message || errorText;
    if (button) button.textContent = errorText;
  } finally {
    window.setTimeout(() => {
      if (button) {
        button.disabled = false;
        button.textContent = originalText;
      }
    }, 900);
  }
});
